'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function formatDate(date) {
  const NOW = new Date(date.getTime());
  const pad = (num) => num.toString().padStart(2, "0");
  return NOW.getFullYear() + "/" + pad(NOW.getMonth() + 1) + "/" + pad(NOW.getDate()) + "T" + pad(NOW.getHours()) + ":" + pad(NOW.getMinutes()) + ":" + pad(NOW.getSeconds());
}
function chunkDateRange(from, to, maxDays = 60) {
  if (from > to) {
    throw new Error("#chunkDateRange: `from` parameter must be less than `to`");
  }
  const maxMs = maxDays * 24 * 60 * 60 * 1e3;
  const ranges = [];
  const fromMs = from.getTime();
  const toMs = to.getTime();
  const divisions = Math.ceil((toMs - fromMs) / maxMs);
  for (let i = 0; i < divisions; i++) {
    const currOffset = i * maxMs;
    const newTo = toMs - currOffset;
    const newFrom = Math.max(fromMs, toMs - (currOffset + maxMs));
    ranges.unshift([newFrom, newTo]);
  }
  return ranges;
}

exports.chunkDateRange = chunkDateRange;
exports.formatDate = formatDate;
